import styled from '@emotion/styled';

export const Root = styled.button<{ size: number }>`
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: flex;
  align-items: center;
  justify-content: center;

  input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  > * {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
